import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { createUserApiKey } from '@/api/v4/user-api-key.api';
import { QueryKey } from '@/config/query-client';
import { notify } from '@/ui/snackbar/notify';

export const useCreateUserApiKey = () => {
  const { t } = useTranslation('default');
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: createUserApiKey,
    onError: () => {
      notify({
        message: t`unknownError`,
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [QueryKey.UserApiKeys] });
    },
  });

  return {
    createToken: mutation.mutateAsync,
    isLoading: mutation.isPending,
  };
};
